const MSG_SERVER_ERR = '抱歉~ 我們好像出了點問題😱';
const MSG_NETWORK_ERR = '發送請求失敗💔  也許網路不穩?';

const defOpt = {
  headers: new Headers({
    'Accept': 'application/json'
  })
};

fetch.delete = function(url, option = {}) {
  let opt = Object.assign({}, defOpt, option);
  opt.method = 'DELETE';
  opt.headers.set('Content-Type', 'application/json');
  opt.body = getRequestBody(opt.params);
  return this._fetch(url, opt);
};

fetch.post = function(url, option = {}) {
  let opt = Object.assign({}, defOpt, option);
  opt.method = 'POST';
  opt.headers.set('Content-Type', 'application/json');
  opt.body = getRequestBody(opt.params);
  return this._fetch(url, opt);
};

fetch.put = function(url, option = {}) {
  let opt = Object.assign({}, defOpt, option);
  opt.method = 'PUT';
  opt.headers.set('Content-Type', 'application/json');
  opt.body = getRequestBody(opt.params);
  return this._fetch(url, opt);
};

fetch.patch = function(url, option = {}) {
  let opt = Object.assign({}, defOpt, option);
  opt.method = 'PATCH';
  opt.headers.set('Content-Type', 'application/json');
  opt.body = getRequestBody(opt.params);
  return this._fetch(url, opt);
};

fetch.get = function(url, option = {}) {
  let opt = Object.assign({}, defOpt, option);
  opt.method = 'GET';
  if (!opt.params) {
    return this._fetch(url, opt);
  }

  let queryStr = getRequestQueryString(opt.params);
  url = url.endsWith('?') ? `${url}${queryStr}` : `${url}?${queryStr}`;

  return this._fetch(url, opt);
};

fetch._fetch = function(url, opt) {
  return new Promise((resolve, reject) => {
    fetch(url, opt)
      .then(res => {
        if (res.ok) {
          resolve(res);
        } else {
          let err = new Error();
          err.response = res;
          throw err;
        }
      })
      .catch(err => {
        let msg = err.response ? MSG_SERVER_ERR : MSG_NETWORK_ERR;
        reject(new Error(msg));
      })
  });
};

function getRequestBody(params) {
  if (!params) {
    return '';
  }
  if (params === 'string') {
    return params;
  }

  let paramsObj = {};
  for (let key in params) {
    if (!params.hasOwnProperty(key)) {
      continue;
    }
    paramsObj[key] = params[key];
  }

  return JSON.stringify(paramsObj);
}

function getRequestQueryString(params) {
  if (!params) {
    return '';
  }
  if (params === 'string') {
    return params;
  }

  let paramList = [];
  // compose query string
  for (let key in params) {
    if (!params.hasOwnProperty(key)) {
      continue;
    }

    let value = params[key];
    if (value === null || value === undefined) {
      continue;
    }

    let encodedKey = encodeURIComponent(key);
    let encodedValue = encodeURIComponent(value);
    paramList.push(`${encodedKey}=${encodedValue}`);
  }
  return paramList.join('&');
}